import React from 'react';
import { ListContent } from '@components/Feed/ListViews/components/ListContent';
import { ListMinimalUser } from '@components/Feed/ListViews/components/ListMinimalUser';
import { ToggledAvatar } from '@components/Feed/ListViews/components/ToggledAvatar';
import { Container, SubText, Wrapper } from '@components/Feed/ListViews/components/shared';
import { AccessibleLink } from '@components/main-components/link/AccessibleLink';
import { MediaQuery } from '@context/mediaQuery';
import type { FragmentType } from '@graphql/reactQuery';
import { getFragment } from '@graphql/reactQuery';
import { MinimalUserFragmentDoc, PlaylistActivityInfoFragmentDoc } from '@graphql/reactQuery';
import { webappUriPath } from '@utils/url';

export const ReleasePlaylistAddedList = ({
  userFrag,
  playlistFrag,
  isoDateString,
}: {
  userFrag: FragmentType<MinimalUserFragmentDoc>;
  playlistFrag: FragmentType<PlaylistActivityInfoFragmentDoc>;
  isoDateString: string;
}) => {
  const { laptop, desktop } = MediaQuery.useContainer();
  const forceMobileView = laptop && !desktop;

  const { name: playlistName, webappUri: playlistWebappUri } = getFragment(
    PlaylistActivityInfoFragmentDoc,
    playlistFrag,
  );

  const { avatar, username, publicAddress, webappUri } = getFragment(
    MinimalUserFragmentDoc,
    userFrag,
  );

  const user = (
    <Wrapper margin="first">
      <ListMinimalUser userFrag={userFrag} forceMobileView={forceMobileView} />
    </Wrapper>
  );
  return (
    <Container>
      <ToggledAvatar
        src={avatar?.url}
        username={username}
        walletAddress={publicAddress}
        userWebappUri={webappUri}
        forceMobileView={forceMobileView}
      />
      <ListContent isoDateString={isoDateString} truncateChildren forceMobileView={forceMobileView}>
        {user}
        <SubText>added this Sound to&nbsp;</SubText>
        <AccessibleLink pathnameUri={webappUriPath(playlistWebappUri)}>
          <SubText black className="playlist-name">
            {playlistName}&nbsp;
          </SubText>
        </AccessibleLink>
      </ListContent>
    </Container>
  );
};
